import {
  FETCH_ACCOUNT_CONTENT_STATUS,
  SET_ACCOUNT_CONTENT_STATUS_FETCHING,
  SET_ACCOUNT_CONTENT_STATUS_ERRORED,
  REPLACE_ACCOUNT_CONTENT_STATUS,
} from 'constants/account/contentStatus';

export const fetchAccountContentStatus = () => ({
  type: FETCH_ACCOUNT_CONTENT_STATUS,
});

export const setAccountContentStatusFetching = () => ({
  type: SET_ACCOUNT_CONTENT_STATUS_FETCHING,
});

export const replaceAccountContentStatus = data => ({
  type: REPLACE_ACCOUNT_CONTENT_STATUS,
  payload: data,
});

export const setAccountContentStatusErrored = error => ({
  type: SET_ACCOUNT_CONTENT_STATUS_ERRORED,
  payload: { error },
});
